import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { clearWhyChooseID, setWhyChooseID } from "./whychooseSlice";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import LinkEdit from "../../components/drawer/LinkEdit";
import {
  ActiveInactiveWhyChoose,
  deleteWhyChoose,
  getAllWhyChoose,
} from "./services/whychoose.service";

const WhyChoose: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllWhyChoose());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteWhyChooseDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Why Choose List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Add New Why Choose"
              drawerName="whychooseForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <WhyChooseGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const WhyChooseGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const WhyChooseList = useAppSelector(
    (state) => state.whychoose.WhyChooseList,
  );
  const loading = useAppSelector((state) => state.whychoose.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [expandedRow, setExpandedRow] = useState(null);
  const truncateDescription = (Description: string) => {
    if (!Description) return "";
    const maxLength = 100;
    if (Description.length <= maxLength) return Description;
    return Description.substring(0, maxLength) + "...";
  };

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? WhyChooseList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteWhyChoose"));
      dispatch(setWhyChooseID(ID));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.ID}
            drawerName="whychooseForm"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 1 || props.index === 2 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false,
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveWhyChoose(data)).then((response: any) => {
        // dispatch(getAllWhyChoose());
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllWhyChoose());
        } else {
          dispatch(getAllWhyChoose());
        }
      });
    };

    return (
      <td
        style={{ textAlign: "center", ...props.style }}
        className={props.className}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {WhyChooseList && WhyChooseList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          className="responsive-table"
          data={
            filter
              ? filterBy(WhyChooseList, filter).slice(
                  page.skip,
                  page.take + page.skip,
                )
              : WhyChooseList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={WhyChooseList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="Title"
            title="Customer Name"
            cells={{
              data: (props: any) => (
                <td
                  className={`${isEditAccess ? "hoverableName" : "normalName"}`}
                >
                  {isEditAccess ? (
                    <LinkEdit
                      ID={props.dataItem.ID}
                      drawerName="whychooseForm"
                      label={props.dataItem?.Title}
                    />
                  ) : (
                    props.dataItem?.Title
                  )}
                </td>
              ),
            }}
          />

          <Column
            field="Description"
            title="Description"
            cells={{
              data: (props: any) => (
                <td>
                  <div
                    className="remarks-content"
                    dangerouslySetInnerHTML={{
                      __html:
                        expandedRow === props.dataItem?.ID
                          ? props.dataItem?.Description
                          : truncateDescription(props.dataItem?.Description),
                    }}
                  />
                  {props.dataItem?.Description?.length > 100 && (
                    <span
                      className="readmore-btn"
                      style={{
                        textAlign: "right",
                      }}
                      onClick={() =>
                        setExpandedRow(
                          expandedRow === props.dataItem?.ID
                            ? null
                            : props.dataItem?.ID,
                        )
                      }
                    >
                      <u>
                        {expandedRow === props.dataItem?.ID
                          ? "Read Less"
                          : "Read More"}
                      </u>
                    </span>
                  )}
                </td>
              ),
            }}
          />
          <Column
            field="Image"
            title="WhyChoose Image"
            width={110}
            cells={{
              data: (props: any) => (
                <td>
                  <Avatar
                    style={{
                      width: 45,
                      height: 45,
                      flexBasis: 20,
                      padding: 10,
                    }}
                    rounded={"full"}
                    type={"image"}
                  >
                    <img
                      src={props.dataItem?.Image}
                      alt="WhyChoose Image"
                      width={50}
                      onClick={() => window.open(props.dataItem?.Image)}
                      height={50}
                    />
                  </Avatar>
                </td>
              ),
            }}
          />
          <Column
            field="ID"
            title="Status"
            cells={{ data: MyActiveInActtiveCommandCell }}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cells={{ data: MyEditCommandCell }}
              width={"110px"}
              locked={true}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteWhyChooseDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.whychoose.loading);
  const WhyChooseID = useAppSelector((state) => state.whychoose.WhyChooseID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteWhyChoose(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllWhyChoose());
        dispatch(closeDialog());
        dispatch(clearWhyChooseID());
      } else {
        dispatch(getAllWhyChoose());
        dispatch(closeDialog());
        dispatch(clearWhyChooseID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteWhyChoose" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete WhyChoose"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this WhyChoose ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(WhyChooseID)}
                  type="button"
                  disabled={loading}
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default WhyChoose;
